export default "__VITE_ASSET__BuELmkLX__"